import '/Users/yannbraga/open-source/storybook/code/node_modules/@storybook/addon-essentials/dist/backgrounds/manager.mjs';